import { useEffect } from "react";
import "./ComposeModal.css";
import "./MessagingButtons.css";
import {
  ComposeState,
  MessageTemplate,
} from "../../../models/MessageModels";
import MessageComposer from "./MessageComposer";

interface ComposeModalProps {
  isOpen: boolean;
  compose: ComposeState;
  templates: MessageTemplate[];
  orgName: string;
  previewClient: { fullName: string; phone: string } | null;
  selectedCount: number;
  sending: boolean;
  onChange: (next: ComposeState) => void;
  onSend: () => void;
  onCreateCampaign: () => void;
  onClose: () => void;
}

const ComposeModal = ({
  isOpen,
  compose,
  templates,
  orgName,
  previewClient,
  selectedCount,
  sending,
  onChange,
  onSend,
  onCreateCampaign,
  onClose,
}: ComposeModalProps) => {
  useEffect(() => {
    if (!isOpen) return;
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="msg-compose-overlay"
      role="dialog"
      aria-modal="true"
      aria-label="Compose message"
      onClick={onClose}
    >
      <div
        className="msg-compose-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="msg-compose-modal__header">
          <h3>Compose message</h3>
          <button
            className="msg-compose-modal__close"
            onClick={onClose}
            aria-label="Close"
            disabled={sending}
          >
            ×
          </button>
        </div>

        <MessageComposer
          compose={compose}
          templates={templates}
          orgName={orgName}
          previewClient={previewClient}
          selectedCount={selectedCount}
          sending={sending}
          showTitle={false}
          onChange={onChange}
          onSend={onSend}
          onCreateCampaign={onCreateCampaign}
        />
      </div>
    </div>
  );
};

export default ComposeModal;
